import { useAuth } from "@clerk/react";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { resetTenant } from "@/store/tenants/tenantsSlice";
import { api } from "@/services/api";

// Bridges Clerk session lifecycle events to the app's Redux state.
//
// Under MSAL, main.tsx wired ACQUIRE_TOKEN_FAILURE / ACTIVE_ACCOUNT_CHANGED
// to a persistor.purge() + resetTenant() + window.location.reload(). Under
// Clerk we only need the semantic core of that: on the signed-in -> signed-out
// transition, drop the tenant slice and invalidate the RTK Query cache so
// the next signed-in session starts from a clean slate. We deliberately
// skip window.location.reload() — that was an MSAL-era workaround for a
// tab-sync race that Clerk (BroadcastChannel-based session sync) doesn't
// exhibit. React re-renders under <SignedOut> naturally.
//
// Renders nothing; mounted once inside <ClerkLoaded> in App.tsx.
const ClerkSessionSideEffects = () => {
    const { isSignedIn } = useAuth();
    const previous = useRef<boolean | undefined>(undefined);
    const dispatch = useDispatch();

    useEffect(() => {
        if (previous.current === true && isSignedIn === false) {
            dispatch(resetTenant());
            dispatch(api.util.resetApiState());
        }
        previous.current = isSignedIn;
    }, [isSignedIn, dispatch]);

    return null;
};

export default ClerkSessionSideEffects;
